import React, { useEffect, useRef, useState } from "react";
import productImage from "../../../assets/contactus.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import SC from "./style";
import Modal from "../../../components/Modal";

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const scaleUp = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: { scale: 1, opacity: 1, transition: { duration: 0.5 } },
};

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    message: "",
    location: { lat: null, lon: null },
    browserData: {
      userAgent: navigator.userAgent,
      screenSize: `${window.screen.width}x${window.screen.height}`,
      language: navigator.language,
    },
  });
  const [loading, setLoading] = useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const recaptchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  // // Get user location
  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         setFormData((prev) => ({
  //           ...prev,
  //           location: {
  //             lat: position.coords.latitude,
  //             lon: position.coords.longitude,
  //           },
  //         }));
  //       },
  //       (error) => console.error("Geolocation error:", error),
  //       { timeout: 10000 }
  //     );
  //   }
  // }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert("Please complete the reCAPTCHA.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `/api/rest/users/v2/contact`,
        {
          ...formData,
          captcha: captchaToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: process.env.REACT_APP_API_KEY,
          },
        }
      );
      setIsModalOpen(true);

      console.log("Response:", response.data);

      // Reset form data and CAPTCHA
      setFormData({ name: "", email: "", phone_number: "", message: "" });
      recaptchaRef.current?.reset();
      setCaptchaToken(""); // Reset captcha token
      setLoading(false);
    } catch (error) {
      // Reset form data and CAPTCHA
      setFormData({ name: "", email: "", phone_number: "", message: "" });
      recaptchaRef.current?.reset();
      setCaptchaToken(""); // Reset captcha token
      setLoading(false);
      console.error("Error:", error.response?.data || error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCaptchaChange = (token) => {
    setCaptchaToken(token); // Save token
    setIsCaptchaValid(!!token); // Ensure the token is valid
  };

  return (
    <>
      <SC.MainContainer initial="hidden" animate="visible" exit="hidden">
        <SC.Container variants={fadeIn}>
          <SC.ImageContainer variants={scaleUp}>
            <SC.Image
              src={productImage}
              alt="Team collaborating on a project"
            />
          </SC.ImageContainer>
          <SC.FormSection variants={fadeIn}>
            <div>
              <SC.Label variants={fadeIn}>Contact us</SC.Label>
              <SC.Title variants={fadeIn}>
                Let's Connect & Elevate Your Workflow!
              </SC.Title>
              <SC.Subtitle variants={fadeIn}>
                Have questions or need a demo?
              </SC.Subtitle>
            </div>
            <SC.Form onSubmit={handleSubmit} variants={fadeIn}>
              <SC.Input
                type="text"
                name="name"
                placeholder="Your full name*"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <SC.InputWrapper>
                <SC.Input
                  type="email"
                  name="email"
                  placeholder="Your email address*"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <SC.Input
                  type="tel"
                  name="phone_number"
                  placeholder="Your phone number"
                  value={formData.phone_number}
                  onChange={handleChange}
                />
              </SC.InputWrapper>

              <SC.TextArea
                name="message"
                placeholder="Message*"
                value={formData.message}
                onChange={handleChange}
                required
              />

              <SC.RecaptchaWrapper>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey="6Ld9ItcqAAAAAGfJwyeL76iqasJcMzR1Gm2yDlEm"
                  onChange={onCaptchaChange}
                />
              </SC.RecaptchaWrapper>
              <SC.SubmitButton
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                disabled={!isCaptchaValid || loading}
                aria-label="Submit the form"
              >
                Submit Now
              </SC.SubmitButton>
            </SC.Form>
          </SC.FormSection>
        </SC.Container>
      </SC.MainContainer>
      {isModalOpen && (
        <Modal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      )}
    </>
  );
}

export default ContactUs;
